import { phoneValidator, idNumberValidator } from '@/util/validator'
import global from '@/util/mixin/global'
import Review from './partial/review'

export default {
  mixins: [global],
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur,change' },
        ],
        gender: [
          { type: 'number', required: true, message: '请选择性别', trigger: 'blur,change' },
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur,change' },
          { validator: phoneValidator('请输入联系方式', '请输入正确格式的手机号'), trigger: 'blur,change' },
        ],

        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur,change' },
          { validator: idNumberValidator(), trigger: 'blur,change' },
        ],
        companyId: [
          { type: 'number', required: true, message: '请选择所属企业', trigger: 'blur,change' },
        ],
        groupIds: [
          { type: 'number', required: true, message: '请选择所属分组', trigger: 'blur,change' },
        ],
        entryTime: [
          { type: 'date', required: true, message: '请选择入职时间', trigger: 'blur,change' },
        ],
        imagePath: [
          { required: true, message: '请上传头像', trigger: 'blur,change' },
        ],
      },
      def: {},
      form: {
        id: null,
        name: null,
        idcard: null,
        gender: null,
        phone: null,
        workNumber: null,
        imgPath: null,
        entryTime: null,
        companyId: null,
        groupIds: null,
        remark: null,
        politic: null
      },
      id: null,
      loading: false,
      isCreate: true,
      groups: [],
      modalVisible: false,
      photos: [],
      reviewable: false
    }
  },

  computed: {
    buttonLabel() {
      return this.reviewable ? '审核' : '确定'
    },
    itemTitle() {
      return (this.reviewable ? '审核' : (this.id ? '编辑' : '新增')) + '快递员'
    },
  },
  created() {
    this.def = { ...this.form }
  },

  methods: {

    init(id, type, reviewable = false) {
      this.id = id
      this.reset()
      this.type = type
      this.modalVisible = true
      this.reviewable = reviewable
      if (this.id) {
        this.query()
      }

      if (this.isCompany) {
        if (this.userinfo.companys) {
          this.form.companyId = this.userinfo.companys[0].id
          this.updateGroups()
        }
      }
    },

    query() {
      this.loading = true

      this.$request.courier(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
        if (resp.data.province) {
          this.area.push(resp.data.province)
          if (resp.data.city) {
            this.area.push(resp.data.city)
            if (resp.data.area) {
              this.area.push(resp.data.area)
            }
          }
        }

        this.photos = resp.data.photos ? resp.data.photos.split(';') : []
        this.updateGroups()
        this.loading = false
      })
    },

    reset() {
      this.$utils.fill(this.form, this.def)
      this.$refs['form'].resetFields()
      console.log('reset photos')
      this.photos = []
      this.area = []
    },
    review() {
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review courier-id={this.id} />
        },
        onOk: () => {
          //this.query()
          this.modalVisible = false
        }
      })
    },

    save() {
      if (this.reviewable) {
        this.$dialog({
          title: '审核',
          width: 550,
          paddingless: true,
          render: (h) => {
            return <Review courier-id={this.id} before-save={this.saveProcess}/>
          },
          onOk: () => {
            this.$emit('update')
            this.modalVisible = false
          }
        })
      } else {
        this.saveProcess()
      }
    },
    saveProcess() {
      //
      let params = { ...this.form }

      if (this.area[0]) params.province = this.area[0]
      if (this.area[1]) params.city = this.area[1]
      if (this.area[2]) params.area = this.area[2]

      params.companyType = this.type
      params.groupIds = [this.form.groupIds]
      this.loading = true
      let promise = this.id ? this.$request.courierUpdate : this.$request.courierCreate
      return promise(params).then(resp => {
        this.loading = false

        if (resp.code) {
          this.$Message.error({ content: resp.msg })
          if (this.reviewable) {
            return Promise.resolve(false)
          }
        } else {

          if (this.reviewable) {
            return Promise.resolve(true)
          } else {
            this.$Message.success('保存成功')
            this.$emit('on-update')
            if (!this.id) {
              this.modalVisible = false
            }
          }
        }
      })
    },

    updateGroups() {

      this.$request.courierGroupByCompanyId(this.form.companyId).then(resp => {
        if (!resp.code) {
          this.groups = (resp.data || []).map(i => ({
            value: i.id,
            label: i.groupName,
            disabled: i.status == 1
          }))
        }
      })
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },

    handleCompanyChange() {
      this.updateGroups()
    }
  },
  render(){
    const slots = {
      footer:() => {
        return <Button loading={this.loading} on-click={() => this.handleSubmit('form')} type="primary">{this.buttonLabel}</Button>
      }
    }
    return <sl-side-panel v-model={this.modalVisible} mask-closable={false} title={this.itemTitle} scopedSlots={slots}>
      <Form class="sm" ref="form" props={{ model: this.form , rules:this.rules , labelWidth:100}}>
        <FormItem label="姓名" prop="name">
          <Input v-model={this.form.name} maxlength={128} />
        </FormItem>
        <FormItem label="证件号码" prop="idcard">
          <Input v-model={this.form.idcard} maxlength={18} disabled={!!this.id} />
        </FormItem>
        <FormItem label="性别" prop="gender">
          <sl-select v-model={this.form.gender} type="radio" dict="$gender"></sl-select>
        </FormItem>
        <FormItem label="电话" prop="phone">
          <Input v-model={this.form.phone} maxlength={18} />
        </FormItem>
        <FormItem label="工号" prop="workNumber">
          <Input v-model={this.form.workNumber} maxlength={64} />
        </FormItem>
        <FormItem label="政治面貌" prop="politic">
          <sl-select v-model={this.form.politic} filterable dict="politic"></sl-select>
        </FormItem>
        <FormItem label="头像" prop="imgPath">
          <sl-upload v-model={this.form.imgPath} type="1">建议尺寸：320*480，支持格式：jpg, png, bmp , gif</sl-upload>
        </FormItem>
        {
          this.reviewable ? [
            <FormItem label="一寸照" prop="phone0">
              <sl-img width="150px" extra={true} public={true} src={this.photos[0]} method="1" />
            </FormItem>,
            <FormItem label="身份证正面" prop="phone1">
              <sl-img width="150px" extra={true} public={true} src={this.photos[1]} method="1" />
            </FormItem>,
            <FormItem label="身份证反面" prop="phone2">
              <sl-img width="150px" extra={true} public={true} src={this.photos[2]} method="1" />
            </FormItem>
          ] : null
        }
        <FormItem label="入职时间" prop="entryTime">
          <DatePicker type="date" v-model={this.form.entryTime}></DatePicker>
        </FormItem>
        {
          this.isAdmin ? <FormItem label="所属企业" prop="companyId">
          <sl-select v-model={this.form.companyId} disabled={!!this.id} dict="company" filterable={true} on-on-change={this.handleCompanyChange}></sl-select>
          </FormItem> : null
        }
        <FormItem label="所属分组" prop="groupIds">
          <sl-select v-model={this.form.groupIds} data={this.groups} filterable={true}></sl-select>
        </FormItem>
        <FormItem label="备注" prop="remark">
          <Input type="textarea" autosize={{minRows: 5,maxRows: 8}} v-model={this.form.remark} />
        </FormItem>
      </Form>
    </sl-side-panel>
  }
}